export { DetailsPreview } from './DetailsPreview';
